import { isExperienceVibe } from '@/features/colors/lib/vibeLookup';
import type { PageExperience } from '@/features/experiences/types';

/**
 * The block printable renderer is the vibe-aware printable path. Legacy and
 * standalone printables stay on their classic styleId templates even when the
 * feature flag is enabled, because they have no explicit vibe to render.
 */
export const shouldUseBlockPrintableRenderer = (
  printableBlockEnabled: boolean,
  effectiveExperience: Pick<PageExperience, 'vibe'>
): boolean =>
  printableBlockEnabled && isExperienceVibe(effectiveExperience.vibe);
